import React, { useEffect, useState } from "react";
import { auth, db, storage } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
import { doc, setDoc, getDoc, collection, getDocs } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const blankProfile = {
  name: "", age: "", area: "", bio: "",
  photo1: "", photo2: "", photo3: "", photo4: "",
  hobbies: [], values: [], traits: []
};

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [page, setPage] = useState("discover");
  const [profile, setProfile] = useState(blankProfile);
  const [allUsers, setAllUsers] = useState([]);
  const [index, setIndex] = useState(0);
  const [matchedUser, setMatchedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [chatText, setChatText] = useState("");

  const stableInputProps = {
    autoComplete: "off",
    autoCorrect: "off",
    spellCheck: false
  };
  const [effect, setEffect] = useState("");

  const hobbies = ["Coffee", "Study", "Gym", "Photography", "Music", "Food", "Travel", "Reading", "Movies"];
  const values = ["Honest", "Kind", "Loyal", "Respectful", "Ambitious", "Creative"];

  useEffect(() => {
    return onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        await loadMyProfile(u.uid);
        await loadUsers(u.uid);
      }
      setLoading(false);
    });
  }, []);

  async function loadMyProfile(uid) {
    const snap = await getDoc(doc(db, "users", uid));
    if (snap.exists() && snap.data().profile) setProfile(snap.data().profile);
  }

  async function loadUsers(uid) {
    const snap = await getDocs(collection(db, "users"));
    const users = [];

    snap.forEach((d) => {
      const data = d.data();

      if (d.id !== uid && data.profile && data.profile.name) {
        users.push({
          uid: d.id,
          email: data.email,
          ...data.profile
        });
      }
    });

    setAllUsers(users);
    setIndex(0);
  }

  async function signup() {
    const r = await createUserWithEmailAndPassword(auth, email, password);
    setUser(r.user);
  }

  async function login() {
    const r = await signInWithEmailAndPassword(auth, email, password);
    setUser(r.user);
    await loadMyProfile(r.user.uid);
    await loadUsers(r.user.uid);
  }

  async function googleLogin() {
    const provider = new GoogleAuthProvider();
    const r = await signInWithPopup(auth, provider);
    setUser(r.user);
    await loadMyProfile(r.user.uid);
    await loadUsers(r.user.uid);
  }

  async function logout() {
    await signOut(auth);
    setUser(null);
    setProfile(blankProfile);
    setMatchedUser(null);
  }

  async function uploadPhoto(key, file) {
    if (!file) return;
    const imageRef = ref(storage, `users/${user.uid}/${key}-${Date.now()}`);
    await uploadBytes(imageRef, file);
    const url = await getDownloadURL(imageRef);
    setProfile((p) => ({ ...p, [key]: url }));
  }

  async function saveProfile() {
    if (!profile.name || !profile.age || !profile.area || !profile.bio) {
      alert("Add name, age, area, and bio.");
      return;
    }
    await setDoc(doc(db, "users", user.uid), {
      email: user.email,
      profile,
      updatedAt: new Date()
    });
    await loadUsers(user.uid);
    setPage("discover");
  }

  function toggle(field, item) {
    setProfile((p) => ({
      ...p,
      [field]: p[field].includes(item)
        ? p[field].filter((x) => x !== item)
        : [...p[field], item]
    }));
  }

  function next() {
    setIndex((index + 1) % Math.max(allUsers.length, 1));
  }

  function pass() {
    setEffect("❌");
    setTimeout(() => setEffect(""), 450);
    next();
  }

  function like() {
    const person = allUsers[index];
    if (!person || person.uid === user.uid) return next();
    setMatchedUser(person);
    setEffect("💛");
    setTimeout(() => setEffect(""), 450);
    setPage("messages");
  }

  function sendMessage() {
    if (!chatText.trim()) return;
    setMessages((m) => [...m, { from: "You", text: chatText }]);
    setChatText("");
  }

  const s = {
    page: { minHeight: "100vh", background: "#f4fff3", color: "#103820", fontFamily: "Arial", paddingBottom: 140 },
    card: { background: "transparent", borderRadius: 26, padding: 22, margin: 14, boxShadow: "0 10px 28px rgba(0,0,0,.10)", boxSizing: "border-box" },
    input: { width: "100%", boxSizing: "border-box", padding: 15, margin: "9px 0", borderRadius: 18, border: "1px solid #ddd", fontSize: 16 },
    btn: { border: "none", borderRadius: 999, padding: "14px 18px", margin: 5, fontWeight: "bold", fontSize: 15 },
    gold: { background: "#ffd700", color: "#103820" },
    green: { background: "#2e8b57", color: "white" },
    red: { background: "#ffe0e0", color: "#9b1c1c" },
    nav: { background: "#111", padding: "8px 4px", display: "grid", gridTemplateColumns: "repeat(5,minmax(0,1fr))", marginTop: 20 },
    navBtn: { background: "transparent", border: "none", color: "white", fontSize: 11, fontWeight: "bold" }
  };

  function Header() {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, padding: 14, background: "transparent",  }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img
            src="/logo-main.jpg"
            alt="Bondhu"
            style={{
              width: 210,
              height: 210,
              objectFit: "cover",
              objectPosition: "center",
              borderRadius: "50%",
              mixBlendMode: "multiply",
              marginBottom: 10
            }}
          />
          <h2 style={{ margin: 0 }}>Bondhu</h2>
        </div>
        <button style={{ ...s.btn, ...s.red }} onClick={logout}>Logout</button>
      </div>
    );
  }

  function Nav() {
    return (
      <div style={s.nav}>
        {[
          ["discover", "💛", "discover"],
          ["profile", "👤", "profile"],
          ["events", "☕", "events"],
          ["messages", "💬", "messages"],
          ["premium", "⭐", "premium"]
        ].map(([key, icon, label]) => (
          <button key={key} style={s.navBtn} onClick={() => setPage(key)}>
            <div>{icon}</div><div>{label}</div>
          </button>
        ))}
      </div>
    );
  }

  function Shell({ children }) {
    return <div style={s.page}><Header />{children}<Nav /></div>;
  }

  if (loading) return <div style={s.page}>Loading...</div>;

  if (!user) {
    return (
      <div style={{ ...s.page, display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#064b2b,#2e8b57,#ffd700)" }}>
        <div style={{ ...s.card, width: "90%", maxWidth: 430, textAlign: "center" }}>
          <img src="/logo-main.jpg" alt="Bondhu" style={{
              width: 170,
              borderRadius: 28,
              objectFit: "cover",
              boxShadow: "0 12px 35px rgba(0,0,0,.14)",
              marginBottom: 10
            }} />
          <h1>Bondhu 💛</h1>
          <p>Find people to talk, chill, and connect with.</p>
          <input {...stableInputProps} style={s.input} placeholder="Email" defaultValue={email} onBlur={(e) => setEmail(e.target.value)} />
          <input {...stableInputProps} style={s.input} placeholder="Password" type="password" defaultValue={password} onBlur={(e) => setPassword(e.target.value)} />
          <button style={{ ...s.btn, ...s.gold, width: "100%" }} onClick={signup}>Sign Up</button>
          <button style={{ ...s.btn, ...s.green, width: "100%" }} onClick={login}>Login</button>
          <button style={{ ...s.btn, width: "100%", background: "transparent", border: "1px solid #ddd" }} onClick={googleLogin}>Continue with Google</button>
        </div>
      </div>
    );
  }

  if (page === "profile") {
    return (
      <Shell>
        <div style={s.card}>
          <h1>👤 Create your profile</h1>
          {["photo1", "photo2", "photo3", "photo4"].map((k, i) => (
            <div key={k} style={{ border: "1px dashed #ccc", borderRadius: 18, padding: 12, marginBottom: 12 }}>
              <b>{i === 0 ? "Main Photo" : `Photo ${i + 1}`}</b><br />
              <input type="file" accept="image/*" onChange={(e) => uploadPhoto(k, e.target.files[0])} />
              {profile[k] && <img src={profile[k]} alt="" style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 16, display: "block", marginTop: 8 }} />}
            </div>
          ))}
          <input {...stableInputProps} style={s.input} placeholder="Name" defaultValue={profile.name} onBlur={(e) => setProfile({ ...profile, name: e.target.value })} />
          <input {...stableInputProps} style={s.input} placeholder="Age" defaultValue={profile.age} onBlur={(e) => setProfile({ ...profile, age: e.target.value })} />
          <input {...stableInputProps} style={s.input} placeholder="Area" defaultValue={profile.area} onBlur={(e) => setProfile({ ...profile, area: e.target.value })} />
          <textarea {...stableInputProps} style={s.input} placeholder="Bio" defaultValue={profile.bio} onBlur={(e) => setProfile({ ...profile, bio: e.target.value })} />
          <h3>Hobbies</h3>
          {hobbies.map((h) => <button key={h} style={{ ...s.btn, ...(profile.hobbies.includes(h) ? s.gold : {}) }} onClick={() => toggle("hobbies", h)}>{h}</button>)}
          <h3>Values</h3>
          {values.map((v) => <button key={v} style={{ ...s.btn, ...(profile.values.includes(v) ? s.gold : {}) }} onClick={() => toggle("values", v)}>{v}</button>)}
          <br />
          <button style={{ ...s.btn, ...s.green }} onClick={saveProfile}>Save Profile</button>
        </div>
      </Shell>
    );
  }

  if (page === "discover") {
    const person = allUsers[index];
    return (
      <Shell>
        {effect && <div style={{ position: "fixed", top: "35%", left: "50%", transform: "translate(-50%,-50%)", fontSize: 90, zIndex: 999 }}>{effect}</div>}
        {!person ? (
          <div style={s.card}>
            <h1>No profiles yet</h1>
            <p>You will not see yourself here. Ask another person to save a profile, then refresh.</p>
            <button style={{ ...s.btn, ...s.green }} onClick={() => loadUsers(user.uid)}>Refresh</button>
          </div>
        ) : (
          <div style={{ ...s.card, background: "#082015", color: "white" }}>
            <div style={{ height: 340, borderRadius: 24, overflow: "hidden", background: "#2e8b57", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {person.photo1 ? <img src={person.photo1} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "☕"}
            </div>
            <h1>{person.name}, {person.age}</h1>
            <p>📍 {person.area}</p>
            <p>{person.bio}</p>
            <button style={{ ...s.btn, ...s.red }} onClick={pass}>✕ Pass</button>
            <button style={{ ...s.btn, ...s.gold }} onClick={like}>💛 Like</button>
          </div>
        )}
      </Shell>
    );
  }

  if (page === "messages") {
    return (
      <Shell>
        <div style={s.card}>
          <h1>💬 Messages</h1>
          {!matchedUser ? <p>Chat unlocks after you like someone.</p> : (
            <>
              <h2>Chat with {matchedUser.name}</h2>
              <div style={{ minHeight: 180, background: "#f4fff3", borderRadius: 18, padding: 12 }}>
                {messages.map((m, i) => <p key={i}><b>{m.from}:</b> {m.text}</p>)}
              </div>
              <input {...stableInputProps} style={s.input} placeholder="Type message" defaultValue={chatText} onBlur={(e) => setChatText(e.target.value)} />
              <button style={{ ...s.btn, ...s.gold }} onClick={sendMessage}>Send</button>
            </>
          )}
        </div>
      </Shell>
    );
  }

  if (page === "events") return <Shell><div style={s.card}><h1>☕ Events</h1><input {...stableInputProps} style={s.input} placeholder="Event title" /><input {...stableInputProps} style={s.input} placeholder="Location" /><label>Date</label><input {...stableInputProps} style={s.input} type="date" /><label>Time</label><input {...stableInputProps} style={s.input} type="time" /><button style={{ ...s.btn, ...s.gold }}>Post Meetup</button></div></Shell>;

  if (page === "premium") return <Shell><div style={s.card}><h1>⭐ Premium</h1><p>Unlimited swipes, see likes, more matches.</p><button style={{ ...s.btn, ...s.gold }}>Pay Soon</button></div></Shell>;

  return null;
}
